import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<Response, PendingPaymentApprovalBody>({
    query: (body) => ({
      url: `v4/pitch-owner/wallet/${body.wallet_topup_id}/apple-pay/init-payment-transaction`,
      method: 'POST',
      body,
    }),
  });

export interface PendingPaymentApprovalBody {
  wallet_topup_id: string;
}
